export default {
    Metadata: {
        Name: "isDirtyRecord",
        Description: "Returns true if any value on the selected record is dirty, otherwise returns false.",
        Syntax: "IsDirtyRecord()",
        Keywords: ['Logical'],
        Author: "DataVoke, Inc.",
        UpdatesOnData: true
    },
    execute() {
        try {
            var curExp = app.dv.helpers.exprEng.currexpression;
            if (curExp.gridRecords.Values.length > 0) {
                var gr;
                if (curExp.mvc != null && curExp.mvc.selectedRecord != null) {
                    gr = curExp.mvc.selectedRecord;
                }
                else {
                    gr = curExp.gridRecords.Values[0];
                    if (gr.parentMVC != null && gr.parentMVC.selectedRecord != null) {
                        gr = gr.parentMVC.selectedRecord;
                    }
                }
                return gr.isDirty();
            }
        } catch (e) {
            return false;
        }

        return false;
    },
};

